import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import RealEstatePage from '../pages/RealEstatePage';
import HospitalityPage from '../pages/HospitalityPage';
import ServicesPage from '../pages/ServicesPage'; // Changed from MaintenancePage to ServicesPage
import ContactPage from '../pages/ContactPage';
import PropertyDetailPage from '../pages/PropertyDetailPage';
import AboutPage from '../pages/AboutPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/real-estate" element={<RealEstatePage />} />
      <Route path="/hospitality" element={<HospitalityPage />} />
      <Route path="/services" element={<ServicesPage />} /> {/* Changed path to /services */}
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/property/:id" element={<PropertyDetailPage />} />
    </Routes>
  );
};

export default AppRoutes;